import React from 'react';
import { Accent, SectionHeading } from './SectionHeading';
import { volumes } from '../../data/content';
export function VolumesSection() {
  return <section aria-labelledby="volumes-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-172" data-mp="hvgl64lgx6wp">
      <div className="mx-auto max-w-6xl" data-id="element-173" data-mp="3zv20e1x1hc7">
        <SectionHeading id="volumes-heading" title={<>
              6 volumes pour <Accent data-id="element-175" data-mp="vooga68rckj5">structurer vos formations</Accent> de coiffure
            </>} data-id="element-174" data-mp="7yu47qw9izzy" />

        <ol className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" role="list" data-id="element-176" data-mp="10mzmm6zugcwm">
          {volumes.map(volume => <li key={volume.number} className="flex h-full flex-col overflow-hidden rounded-[20px] bg-white shadow-[0_24px_50px_-36px_rgba(90,70,40,0.45)]" data-id="element-177" data-mp="mw4l5frocy32">
              <div className="flex min-h-[150px] flex-col px-6 pb-6 pt-5" style={{
            backgroundColor: volume.accent
          }} data-id="element-178" data-mp="1em94rc7m1h38">
                <span className="self-start rounded-full bg-white/70 px-3 py-1 font-body text-[10px] font-bold uppercase tracking-[0.2em] text-brand-charcoal/75" data-id="element-179" data-mp="1jgn4fqtb2adp">
                  Volume {volume.number}
                </span>
                <h3 className="mt-auto pt-5 font-display text-[1.4rem] font-bold leading-[1.12] text-brand-charcoal" data-id="element-180" data-mp="masxgrwzva1i">
                  {volume.title}
                </h3>
              </div>
              <p className="flex-1 px-6 py-5 text-[14px] leading-relaxed text-brand-charcoal/65" data-id="element-181" data-mp="vbr1ha7fnhk3">{volume.description}</p>
            </li>)}
        </ol>
      </div>
    </section>;
}